var _path, _path2, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdversMediaV02Orange = function SvgAdversMediaV02Orange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 26h16v20H12zM12 28H8v16h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m28 26 23.46-15.015a1 1 0 0 1 1.54.842v48.346a1 1 0 0 1-1.54.842L28 46M20.621 68.485 15 46h10l5.379 21.515A2 2 0 0 1 28.439 70h-5.877a2 2 0 0 1-1.94-1.515Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 24,
    r: 5,
    fill: "url(#advers-media-V02-orange_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 43,
    r: 13,
    fill: "url(#advers-media-V02-orange_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "advers-media-V02-orange_svg__a",
    x1: 58.122,
    x2: 47.995,
    y1: 23.846,
    y2: 23.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "advers-media-V02-orange_svg__b",
    x1: 72.317,
    x2: 45.986,
    y1: 42.598,
    y2: 42.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgAdversMediaV02Orange;